<template>
  <div class="relative flex py-5 items-center">
    <div class="flex-grow border-t border-gray-400"></div>
    <span class="flex-shrink mx-4 text-3xl font-bold">Data Orang Tua</span>
    <div class="flex-grow border-t border-gray-400"></div>
  </div>

  <div class="space-y-4">
    <div class="border-b border-gray-900/10 pb-12 px-8 py-20 mt-4 shadow-md rounded-xl bg-white">
      <h2 class="text-base text-gray-800 font-medium font-sans">Data Orang Tua</h2>
      <p class="text-sm text-gray-500 font-medium pb-6 border-b">Informasi data orang tua</p>

      <!-- Nama Ayah -->
      <div class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3">
        <div class="sm:col-span-1 content-center">
          <label for="nama_ayah" class="block leading-6 text-gray-600 text-sm font-medium font-sans mt-2">Nama Ayah</label>
        </div>
        <div class="sm:col-span-2">
          <input
            id="nama_ayah"
            name="nama_ayah"
            type="text"
            :value="modelValue.nama_ayah"
            @input="updateField('nama_ayah', $event.target.value)"
            autocomplete="nama_ayah"
            class="block max-w-lg w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>

      <!-- Nama Ibu -->
      <div class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 border-t">
        <div class="sm:col-span-1 content-center">
          <label for="nama_ibu" class="block leading-6 text-gray-600 text-sm font-medium font-sans mt-2">Nama Ibu</label>
        </div>
        <div class="sm:col-span-2">
          <input
            id="nama_ibu"
            name="nama_ibu"
            type="text"
            :value="modelValue.nama_ibu"
            @input="updateField('nama_ibu', $event.target.value)"
            autocomplete="nama_ibu"
            class="block max-w-lg w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>

      <!-- Nomor HP -->
      <div class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 border-t">
        <div class="sm:col-span-1 content-center">
          <label for="nomor_hp_ortu" class="block leading-6 text-gray-600 text-sm font-medium font-sans mt-2">Nomor HP Orang Tua</label>
        </div>
        <div class="sm:col-span-2">
          <input
            id="nomor_hp_ortu"
            name="nomor_hp_ortu"
            type="text"
            :value="modelValue.nomor_hp_ortu"
            @input="updateField('nomor_hp_ortu', $event.target.value)"
            autocomplete="nomor_hp_ortu"
            class="block max-w-lg w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="mt-6 flex items-center justify-end gap-x-6">
    <button type="button" class="text-sm font-semibold leading-6 text-gray-900" @click="prev">kembali</button>
    <button
      @click="next"
      class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
    >
      Selanjutnya
    </button>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";

const props = defineProps({
  modelValue: Object,
});

const emit = defineEmits(["prev", "next", "update:modelValue"]);

const updateField = (field, value) => {
  emit("update:modelValue", { ...props.modelValue, [field]: value });
};

const next = () => {
  emit("next");
};
const prev = () => {
  emit("prev");
};
</script>

<style></style>
